import EditButton from '@/entities/Admin'

export const Article = ({ article }) => {
    function createMarkup() {
        return { __html: article.description }
    }

    return (
        <div className="Article">
            {article && (
                <>
                    <EditButton item={'blog'} item_id={article.blog_id} />{' '}
                    {/* админкая кнопка редактировать */}
                    <h1>{article.title}</h1>
                    <div className={'text-container'}>
                        <div dangerouslySetInnerHTML={createMarkup()} />
                    </div>
                </>
            )}
        </div>
    )
}
